import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import T from 'i18n-react';
import isEqual from 'lodash/isEqual';
import { SelectDropdown } from '@adsk/bim360-matrix-react-components';
import { issueAttributesType } from '../../../../../../../constants/proptype-validation';
import IssueFieldInlineEdit from '../../../../../../IssueFieldInlineEdit';
import FilterSearchIcon from '../../../../../../FilterSearchIcon';

class MultiSelectInlineEdit extends PureComponent {

  constructor(props) {
    super(props);
    const { issue, attributeName } = this.props;

    this.state = {
      value: issue[attributeName],
    };
  }

  render() {
    const { issue, options, className, attributeName, label, container, styleType, horizontalAlign } = this.props;
    return (
      <div>
        <IssueFieldInlineEdit
          issue={issue}
          className={className}
          data-testid={this.props['data-testid']}
          attributeName={attributeName}
          label={label}
          getDisplayValue={(currentValue) => {
            return options.filter(u => currentValue && currentValue.includes(u.key)).map(u => u.label).join(', ');
          }}
          placeholder={T.translate('unspecifiedValue')}
          container={container}
          styleType={styleType}
          horizontalAlign={horizontalAlign}
        >
          {(currentValue, closeEditMode, updateIssue) => <SelectDropdown
            selectedOptions={options.filter(u => this.state.value && this.state.value.includes(u.key))}
            valueKey="key"
            autofocus
            openOnFocus
            backspaceRemoves={false}
            options={options}
            searchable
            multi
            searchPlaceholder={T.translate('search')}
            searchIcon={<FilterSearchIcon />}
            onClose={closeEditMode}
            onChange={(options) => {
              const value = options.map(o => o.key);
              this.setState({ value });
            }}

            onBlur={() => {
              const { value } = this.state;
              if (!isEqual(value, issue[attributeName])) {
                updateIssue(this.state.value);
              }
            }}
          />}
        </IssueFieldInlineEdit>
      </div>
    );
  }
}

MultiSelectInlineEdit.displayName = 'MultiSelectInlineEdit';


MultiSelectInlineEdit.propTypes = {
  issue: issueAttributesType.isRequired,
  attributeName: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  className: PropTypes.string,
  'data-testid': PropTypes.string,
  options: PropTypes.array.isRequired,
  infoMessage: PropTypes.string,
  container: PropTypes.object,
  styleType: PropTypes.oneOf(Object.values(IssueFieldInlineEdit.StyleTypes)),
  horizontalAlign: PropTypes.bool,
};

export default MultiSelectInlineEdit;
